import {
  Type as InputType,
  Size as InputSize,
  Color as InputColor,
} from 'components/Common/Input';
import { auditCodes } from 'utils/audits/values';
import FormControlSelect, {
  Color as SelectColor,
} from 'components/Common/FormControlSelect';
import msg from 'utils/commonMessages';

import classes from './AuditForm.module.scss';

export const getInputFields = ({ audit }: { audit: any }) => [
  {
    name: 'transactionId',
    renderProps: {
      label: `Transaction ID*`,
      type: InputType.Text,
      readOnly: false,
      size: InputSize.S,
      disabled: false,
      color: InputColor.Gray,
    },
  },
  {
    name: 'auditCode',
    defaultValue: audit.auditCode,
    label: `Audit Code*`,
    labelClassName: classes.labelWidth,
    options: auditCodes,
    type: InputType.Text,
    readOnly: false,
    disabled: false,
    color: SelectColor.Gray,
    component: FormControlSelect,
    placeholder: 'Select code...',
  },
  {
    name: 'merchantName',
    renderProps: {
      label: `Merchant Name*`,
      type: InputType.Text,
      readOnly: false,
      size: InputSize.S,
      disabled: false,
      color: InputColor.Gray,
    },
  },
  {
    name: 'preferredContactEmail',
    renderProps: {
      label: `Preferred Contact Email`,
      type: InputType.Text,
      readOnly: false,
      size: InputSize.S,
      disabled: false,
      color: InputColor.Gray,
      subtext: (
        <>
          Provide an email address if you wish to receive audit updates via
          email. If left blank, you must subscribe to the{' '}
          <a
            href="https://docs.getkard.com/api/notifications/notification-webhook#payload.body.data.auditUpdate"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            auditUpdate notification
          </a>{' '}
          to receive audit updates via webhook. Subscribing to the notification
          is highly recommended.
        </>
      ),
    },
  },
  {
    name: 'auditDescription',
    type: 'textarea',
    renderProps: {
      label: `Audit Description*`,
      labelClassName: classes.labelWidth,
      type: InputType.Text,
      readOnly: false,
      disabled: false,
      placeholder: msg.DescriptionSupportMessage,
      color: InputColor.Gray,
      preventNewLines: true,
      showCharacterLength: true,
    },
  },
];
